import type { PropsWithChildren } from "react";

import { RequiredLabel } from "@/features/flights/components/additional-services/RequiredLabel";
import type { MappedServiceData } from "@/features/flights/components/additional-services/types";
import { getCityNameByAirportCode } from "@/features/flights/components/additional-services/utils";
import { FlightRouteLabel } from "@/features/flights/components/flight-purchase/FlightRouteLabel";
import type { GetFlightAvailabilityTokenOutputDataV2 } from "@/types/codegen";

type Props = PropsWithChildren<{
  routeCodes: string[];
  services: MappedServiceData[];
  flightDetails?: GetFlightAvailabilityTokenOutputDataV2;
  segmentDirection?: "departure" | "return";
}>;

export const RouteCard = ({
  routeCodes,
  services,
  flightDetails,
  segmentDirection,
  children,
}: Props) => {
  const routeLabels = [
    getCityNameByAirportCode(routeCodes[0], flightDetails?.flights),
    getCityNameByAirportCode(routeCodes[1], flightDetails?.flights),
  ];

  return (
    <div className="relative flex flex-col gap-4 rounded-3xl bg-white p-4">
      {services.some((s) => s.mandatory) ? <RequiredLabel /> : null}
      <FlightRouteLabel
        routeLabels={[routeLabels[0], routeLabels[1]]}
        segmentDirection={segmentDirection}
      />
      {children}
    </div>
  );
};
